import miscHelper from "./ra_Helpers/miscHelper";
import * as ss from 'simple-statistics';

export function anycaseEquals(a, b) {
  if (typeof a === 'string' && typeof b === 'string') {
    const trimA = a.trim();
    const trimB = b.trim();

    return trimA.localeCompare(trimB, undefined, { sensitivity: 'accent' }) === 0;
  } else {
    return a === b;
  }

  // return typeof a === 'string' && typeof b === 'string'
  //   ? a.trim().localeCompare(b.trim(), undefined, { sensitivity: 'accent' }) === 0
  //   : a.trim() === b;
}

export function looksLikeADate(possibleDate) {
  // Check if string is like 15-dec.
  // Note: does not check of invalid dates like 30-feb
  let result = false;

  const months = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];

  if (possibleDate.toString().includes('-')) {
    const parts = possibleDate.toLowerCase().split('-');
    if (months.indexOf(parts[1]) !== -1) {
      if (isValidNumber(parts[0], 1, 31)) {
        result = true;
      }
    }
  }

  return result;
}

export function sortedLikeDates(arrayOfLikeDates) {
  const months = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];

  const monthPart = (month) => {
    const parts = month.toLowerCase().split('-');
    return {
      name: parts[1],
      index: months.indexOf(parts[1]) + 1,
    };
  };

  const findMonthIndex = (month) => {
    return months.indexOf(month) + 1;
  };

  const wrapGap = (arrayOfDates) => {
    let firstGap = 0;
    //region check for year wrap.
    // also find first month NOT in the array.
    const joinedDates = arrayOfDates.join('').toLowerCase();
    if (joinedDates.includes('jan') && joinedDates.includes('dec')) {
      // Dates wrap around end of year. So months Jan onwards will use year + 1

      // Find the first month not appearing in the array.
      for(let i = 0; i < months.length; i++) {
        if (!joinedDates.includes(months[i])) {
          firstGap = i + 1;
          break;
        }
      }
    }

    return firstGap;
  };

  if (Array.isArray(arrayOfLikeDates)) {
    if (allDates(arrayOfLikeDates)) {
      const d = new Date();
      const year = d.getFullYear();
      const work = [];

      let firstGap = wrapGap(arrayOfLikeDates);

      //region Build the working array of dates.
      arrayOfLikeDates.forEach( d => {
        const {index} = monthPart(d);

        let xDate = d + "-" + year.toString(10);
        if (firstGap > 0) {
          // Wrapping dates
          if (index >= 1 && index < firstGap) {
            xDate = d + "-" + (year + 1).toString(10);
          } else {
            xDate = d + "-" + year.toString(10);
          }
        }

        const dateObj = new Date(xDate);
        let ye = dateObj.getFullYear().toString();
        let mo = (dateObj.getMonth() + 1).toString().padStart(2, '0')
        let da = dateObj.getDate().toString().padStart(2, '0')
        const sortDate = `${ye}-${mo}-${da}`;

        const srtDate = {
          original: d,
          sortDate,
        }

        work.push(srtDate);
      });
      //endregion

      //region  Now sort work array
      const dateCompare = ( a, b ) => {
        if ( a.sortDate < b.sortDate ){
          return -1;
        }
        if ( a.sortDate > b.sortDate ){
          return 1;
        }
        return 0;
      };

      work.sort( dateCompare );
      //endregion

      return work.map(x => x.original);
    }
  }
}

export function allDates(arrayOfPossibleDates) {
  let result = false;

  if (Array.isArray(arrayOfPossibleDates)) {
    let foundDates = 0;
    arrayOfPossibleDates.forEach(pd => {
      if (looksLikeADate(pd)) {
        foundDates += 1;
      }
    });

    if (foundDates === arrayOfPossibleDates.length) {
      result = true;
    }
  }

  return result;
}

export function allNumeric(arrayOfPossibleNumbers) {
  let result = false;

  if (Array.isArray(arrayOfPossibleNumbers)) {
    let foundNum = 0;
    arrayOfPossibleNumbers.forEach(pn => {
      if (isNumeric(pn)) {
        foundNum += 1;
      }
    });

    if (foundNum === arrayOfPossibleNumbers.length) {
      result = true;
    }
  }

  return result;
}

export function isNumeric(num) {
  return (typeof(num) === 'number' || typeof(num) === "string" && num.trim() !== '') && !isNaN(num);
}

export function isValidNumber(possibleNum, lowValue = null, highValue = null) {
  let result = false;

  if (isNumeric(possibleNum)) {
    result = true;
    const nowValue = Number(possibleNum);
    if (lowValue && isNumeric(lowValue) && nowValue < Number(lowValue)) {
      result = false;
    }
    if (highValue && isNumeric(highValue) && nowValue > Number(highValue)) {
      result = false;
    }
  }

  return result;
}

export function generateTimebasedKey(prefix) {
  const currentDate = new Date();
  const timestamp = currentDate.getTime();
  const KeyId = prefix + timestamp.toString();

  return KeyId;
}

export function makeAColour(possibleColour) {
  if (possibleColour !== '') {
    if (possibleColour.startsWith("#")) {
      return possibleColour.toLowerCase()
    } else {
      return "#" + possibleColour.toLowerCase()
    }
  } else {
    return '';
  }

  return null;
}

export function capitalise(value) {
  let result = '';
  if (value) {
    const firstChar = value.charAt(0).toUpperCase();
    const remainingChars = value.slice(1);

    result = `${firstChar}${remainingChars}`;
  }

  return result;
}

export function ColourLuminance(hex, lum) {

  // validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '');
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  lum = lum || 0;

  // convert to decimal and change luminosity
  var rgb = "#", c, i;
  for (i = 0; i < 3; i++) {
    const partial =  hex.substring(i * 2, (i * 2) + 2);
    c = parseInt(partial, 16);
    c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
    rgb += c;
  }
  rgb = rgb.substring(0, 7);
  return rgb;
}

export function CDFValues(data, sorted = false) {
  // Note: sorted parameter indicates if the data is already sorted.

  // Re-purposed the code specified within the following file
  // https://github.com/DrPaulBrewer/cumulative-distribution-function/blob/master/index.js
  // It uses the MIT license, so there should be no issues with using for our purposes.

  const xs = [];
  const ps = [];
  // let sortedData = [];
  let sortedData = data.toSorted((a,b) => a - b);

  // if (!sorted) {
  //     sortedData = data.toSorted((a,b) => a - b);
  // } else {
  //     sortedData = [...data];
  // }

  let altIndex = 0;
  const length = sortedData.length;
  xs[0] = sortedData[0];
  ps[0] = 1 / length;

  for (var i = 1; i < length; ++i) {
      var value = sortedData[i];
      if (value === xs[altIndex]) {
          ps[altIndex] = (1 + i) / length;
      } else {
          altIndex++;
          xs[altIndex] = value;
          ps[altIndex] = (1 + i) / length;
      }
  }

  var results = [];
  for (var ii = 0; ii < xs.length; ++ii) {
      results.push(
          [xs[ii], ps[ii]]
      );
  }

  return results;
}

// This function will now allow a match on crop name or crop abbreviation.
export function getCropColour(crops, cropname, withGradient = true) {
  let result = null;

  if (crops && cropname) {
    const aCrop = crops.find(c => anycaseEquals(c.Name, cropname) || anycaseEquals(c.abbrev, cropname));

    if (aCrop) {
      const startColour = makeAColour(aCrop.bg_colour);

      if (withGradient) {
        const stopColour = ColourLuminance(startColour, 0.2);
        const perShapeGradient = {x1: 0, y1: 0, x2: 1, y2: 1};
        const gradient = {
          linearGradient: perShapeGradient,
          stops: [[0, startColour], [1, stopColour]],
        };

        result = gradient;
      } else {
        result = makeAColour(aCrop.bg_colour);
      }
    }
  }

  return result;
}

export function ColourDarken(hex, factor) {

  // validate hex string
  hex = String(hex).replace(/[^0-9a-f]/gi, '');
  if (hex.length < 6) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }
  factor = factor || 0;

  // convert to decimal and change luminosity
  var rgb = "#", c, i;
  for (i = 0; i < 3; i++) {
    const partial =  hex.substring(i * 2, (i * 2) + 2);
    c = parseInt(partial, 16);
    const change = Math.round(factor * c);
    c = Math.min( Math.max(0, c - change),  255).toString(16);
    rgb += c;
  }
  rgb = rgb.substring(0, 7);
  return rgb;
}

//region Object Structures for ParallelChart component.
// summaryData object: {  (created by SummariseDataByIndicator function)
//   <crop name>: {
//     colour: '#xxxxxx',
//     <indicator 1>: { (
//       data: [values from api data],
//       max: maximum value in data,
//       mean: calculated mean,
//       min: minimum value in data,
//       total: sum of values in data,
//     }
//     ...
//     <indicator n>: {
//       data: [values from api data],
//       max: maximum value in data,
//       mean: calculated mean,
//       min: minimum value in data,
//       total: sum of values in data,
//     }
//   }
//   foundCrops: ['crop1', ... 'cropn'],
//   maxMins: {  (max/min over all crops)
//     <indicator 1>: { (
//       max: maximum value in data,
//       min: minimum value in data,
//     }
//     ...
//     <indicator n>: {
//       max: maximum value in data,
//       min: minimum value in data,
//     }
// }
// indicators object: {
//   display: user friendly name,
//   details: additional details if applicable,
//   value: used as a key in the UI 'yield',
//   infokey: infodata Key value,
//   units: string',
//   spider: boolean - used to determine if a indicator is displayed,
//   spiderSort: integer - use to order the indicators on the chart,
//   selectable: boolean - is the indicator to appear is select dialog,
//   axisStep: null - not currently used,
//   axisReverse: boolean - used to reverse scale on y axis.
// }
//

export function MakeIndicatorCategories(indicators) {
  const categories = [];

  if (indicators) {
    indicators.forEach(indicator => {
      let catDisplay = indicator.display;
      if (indicator.units !== '') {
        catDisplay += ' (' + indicator.units + ')';
      }
      categories.push(catDisplay);
    });
  }

  return categories;
}

export function MakeParallelChartSeries (summaryData) {
  const series = [];

  if (summaryData) {
    console.log(summaryData);
    if (summaryData.foundCrops) {

      //region Generate scaled data for each crop/indicator
      summaryData.foundCrops.forEach(crop => {
        const cropColour = summaryData[crop].colour;

        const cropSeriesObj = {
          color: cropColour,
          name: capitalise(crop),
          data: [],
          shadow: false,
        };

        summaryData.indicators.forEach(ind => {
          const indicator = ind.value;
          cropSeriesObj.data.push(summaryData[crop][indicator].mean);
        });

        series.push(cropSeriesObj);
      });
      //endregion
    }
  }

  // console.log('Calculated Series', series);
  return series;
}

export function CIndicatorDescription(indicatorVal) {
  let result = '';

  const indicators = miscHelper.sectionCIndicators();

  const indicator = indicators.find(i => anycaseEquals(i.value, indicatorVal));
  if (indicator) {
    result = indicator.display;
  }

  return result;
}

export const ExploreListRowType = {
  reference: 0, // reference rotation
  spacer: 1,    // spacer (blank row)
  normal: 2,    // normal data row
  alternate: 3, // a selected alternative
}

export function ExploreListRowTypeDesc(rowType) {
  if (rowType === ExploreListRowType.reference) {
    return 'Reference';
  }
  if (rowType === ExploreListRowType.alternate) {
    return 'Alternate';
  }

  return '';
}

export function IndicatorSortOrder(indicator) {
  const allIndicators = miscHelper.sectionCIndicators();

  // How is the performance indicator usually sorted?
  let indicatorOrder = 'asc';
  const indicatorDetails = allIndicators.find(i => i.value === indicator);
  if (indicatorDetails) {
    if (indicatorDetails.axisReverse) {
      // So 'normal' sort order is descending
      indicatorOrder = 'desc';
    }
  }

  return indicatorOrder;
}

export function CalcBandYears(season, baseYear) {
  let x1 = baseYear;
  let x2 = baseYear + .99;
  if (season === 'winter') {
    x1 = baseYear + (33 / 100);     // starts Apr
    x2 = baseYear + (66 / 100);     // ends Sep
  }
  if (season === 'summer') {
    x1 = baseYear + (74 / 100);     // starts Oct
    x2 = baseYear + 1 + (16 / 100); // ends Mar
  }
  return {x1, x2};
}

export function FilterWaterBalance(waterBalanceData, seasonalConditions) {
  const results = waterBalanceData.filter(wb => seasonalConditions.includes(wb.condition));
  return results;
}

export function FilterExploreTableData(dbData, baseRotationId, performanceIndicators,) {
  let filtered_data = [];

  const indicatorOrder = [];    // asc = Greater value better, desc = Lesser value better
  performanceIndicators.forEach((indicator, index) => {
    if (indicator !== '') {
      indicatorOrder.push(IndicatorSortOrder(indicator));
    }
  });

  // The rotations MUST have performed better than the reference rotation for
  // the performance indicators selected.

  if (Array.isArray(dbData.rotations) && dbData.rotations.length > 0) {
    // Find the reference rotation first.
    const refRotation = dbData.rotations.find(db => db.BaseRotationId === baseRotationId);
    if (refRotation) {
      filtered_data.push({...refRotation, rowType: ExploreListRowType.reference});

      dbData.rotations.forEach(d => {
        if (d.BaseRotationId !== baseRotationId) {

          let isBetter = true;
          performanceIndicators.forEach((indicator, index) => {
            const refValue = refRotation[indicator];
            const rowValue = d[indicator];

            if (indicatorOrder[index] === 'asc') {
              // Normal ascending order... greater is better
              if (rowValue <= refValue) {
                isBetter = false;
              }
            } else {
              // Descending order... lesser is better
              if (rowValue >= refValue) {
                isBetter = false;
              }
            }
          });

          if (isBetter) {
            filtered_data.push({...d, rowType: ExploreListRowType.normal});
          }
        }
      });
    }

    //region Add a spacer row.
    // add the spacer row.
    const spacerRow = {
      id: 0,
      BaseRotationId: 0,
      RotationName: '',
      rowType: ExploreListRowType.spacer
    };
    const allIndicators = miscHelper.sectionCIndicators();
    allIndicators.forEach((indicator, index) => {
      spacerRow[indicator.value] = null;
    });
    filtered_data.push(spacerRow);
    //endregion
  }

  return filtered_data;
}

export function SortExploreTableData(filteredData, sortOn='', sortOrder = 'asc') {

  // Initial Sorting is on first indicator column.
  if (sortOn !== '') {

    if (Array.isArray(filteredData) && filteredData.length > 0) {

      const indicatorOrder = IndicatorSortOrder(sortOn);

      // Flip the order based on the sort indicator in the header of
      // column.
      let finalSortOrder = indicatorOrder;
      if (sortOrder === 'desc') {
        // Need the oposite of normal sorting order for this indicator.
        finalSortOrder = indicatorOrder === 'desc' ? 'asc' : 'desc';
      }

      const sortRowBy = (field, order) => {
        return function (a, b) {
          // All sorted fields MUST be numeric!
          // Always sort by rowType (ascending) first.
          if (a.rowType !== b.rowType) {
            return a.rowType - b.rowType;
          }

          // Then sort by the indicator column last selected.
          if (field !== '') {
            if (order === 'asc') {
              return a[field] - b[field];
            } else {
              return b[field] - a[field];
            }
          }

          return 0;
        };

      }
      filteredData.sort(sortRowBy(sortOn, finalSortOrder));
    }
  }
}

export function SummariseDataByIndicator(resultsData, indicators, crops, ignoreCrops=['fallow']) {
  const cropData = {indicators: []};
  const maxMin = {};
  let lastCrop = null;
  const foundCropsSet = new Set();

  //region Setup maxMin object.
  // This object is used to calculate the scaling on the spider chart.
  indicators.forEach(indicator => {
    maxMin[indicator.value] = { max: null, min: null};
  });
  //endregion

  if (resultsData) {
    if (resultsData.length > 0) {
      //console.log(resultsData);

      //region Summarise the data.
      resultsData.forEach(dataset => {
        const cropName = dataset.crop;

        // Ignore crops passed in array (will usually only be fallow).
        if (!ignoreCrops.includes(cropName)) {

          if (lastCrop === null || cropName !== lastCrop) {
            foundCropsSet.add(cropName);

            //region Create an empty crop structure if not already there.
            if (!cropData.hasOwnProperty(cropName)) {
              const calculatedColour = getCropColour(crops, cropName, false, true);
              cropData[cropName] = {
                colour: calculatedColour,
              };

              indicators.forEach(ind => {
                const indicator = ind.value;
                cropData[cropName][indicator] = {
                  data: [],
                  mean: null,
                  total: 0,
                  min: null,
                  max: null,
                  count: 0,
                }

                // copy the indicators processed into the summary data object.
                // so that the indicators "travel" with the data.
                // Only do this when processing the first crop.
                if (lastCrop === null) {
                  cropData.indicators.push(ind);
                }
              });
            }
            //endregion
          }

          indicators.forEach(ind => {
            const indicator = ind.value;    // Makes code a little clearer
            const datasetValue = dataset[indicator];
            if (datasetValue !== null) {    // Ignore nulls
              const roundedValue = Math.round(datasetValue * 1000) / 1000;
              //cropData[cropName][indicator].data.push(datasetValue);
              cropData[cropName][indicator].data.push(roundedValue);

              if (cropData[cropName][indicator].min === null || roundedValue < cropData[cropName][indicator].min) {
                cropData[cropName][indicator].min = roundedValue;
              }
              if (cropData[cropName][indicator].max === null || roundedValue > cropData[cropName][indicator].max) {
                cropData[cropName][indicator].max = roundedValue;
              }
              // cropData[cropName][indicator].total += datasetValue;
              cropData[cropName][indicator].count += 1;   // count of non-null values
              cropData[cropName][indicator].total += roundedValue;
              cropData[cropName][indicator].label = ind.display;

              // Update the maxMin object to reflect the highest and lowest values
              // found for this indicator. Will be used to generate the axis later.
              if (maxMin[indicator].min === null || roundedValue < maxMin[indicator].min) {
                maxMin[indicator].min = roundedValue;
              }
              if (maxMin[indicator].max === null || roundedValue > maxMin[indicator].max) {
                maxMin[indicator].max = roundedValue;
              }
            }
          });

          lastCrop = cropName;
        }
      });
      //endregion

      //region Calculate the means and update objects.
      const foundCrops = Array.from(foundCropsSet);
      foundCrops.forEach(crop => {
        indicators.forEach(ind => {
          const indicator = ind.value;
          //const calcMean = cropData[crop][indicator].total / cropData[crop][indicator].data.length;
          const calcMean = cropData[crop][indicator].total / cropData[crop][indicator].count;
          const roundedMean = Math.round(calcMean * 1000) / 1000;
          cropData[crop][indicator].mean = roundedMean;
        });
      });
      cropData.foundCrops = [...foundCrops];
      cropData.maxMins = maxMin;
      //endregion

      return cropData;
    }
  }
}

export function calcMedian(values) {
  const temp = values.slice(0);

  temp.sort((a, b) => a - b);
  const middleIndex = Math.floor(temp.length / 2);

  if (temp.length % 2 === 0) {
    return (temp[middleIndex - 1] + temp[middleIndex]) / 2;
  } else {
    return temp[middleIndex];
  }
}

export function BoxPlotData(values, decimalPlaces = 1, q = [0.05, 0.25, 0.5, 0.75, 0.95]) {
  const result = {
    mean: 0,
    median: 0,
    q1: null,
    q2: null,
    q3: null,
    q4: null,
    q5: null,
    min: null,
    max: null,
    sample_size: 0,
  };

  // m - multiplier for rounding to set number of decimal places.
  const m = Math.trunc(10 ** decimalPlaces);

  // calculate the mean for each simData property
  // in order to calculate to 1 decimal place, we need to perform (Math.round(value * 10)/10)
  if (values.length > 0) {
    result.sample_size = values.length;
    result.mean = Math.round((values.reduce((a, b) => a + b) / values.length) * m) / m;
    // result.min = Math.round(Math.min(values) * m) / m;
    // result.max = Math.round(Math.max(values) * m) / m;
    result.max = Math.round(Math.max(...values) * m) / m;
    result.min = Math.round(Math.min(...values) * m) / m;
    result.median = Math.round(calcMedian(values) * m) / m;

    result.q1 = Math.round(ss.quantile(values, q[0]) * m) / m;
    result.q2 = Math.round(ss.quantile(values, q[1]) * m) / m;
    result.q3 = Math.round(ss.quantile(values, q[2]) * m) / m;
    result.q4 = Math.round(ss.quantile(values, q[3]) * m) / m;
    result.q5 = Math.round(ss.quantile(values, q[4]) * m) / m;
  }

  return result;
}

// This function is NOT complete. Do not use yet.
export function SummariseDataByIndicatorSeasonalConditions(resultsData, indicators, conditions, crops , ignoreCrops=['fallow']) {
  const cropData = {indicators: []};
  const maxMin = {};
  let lastCrop = null;
  const foundCropsSet = new Set();

  //region Setup maxMin object.
  // This object is used to calculate the scaling on the spider chart.
  indicators.forEach(indicator => {
    maxMin[indicator.value] = { max: null, min: null};
  });
  //endregion

  if (resultsData) {
    if (resultsData.length > 0) {
      //console.log(resultsData);

      //region Summarise the data.
      resultsData.forEach(dataset => {
        const cropName = dataset.crop;

        // Ignore crops passed in array (will usually only be fallow).
        if (!ignoreCrops.includes(cropName)) {

          if (lastCrop === null || cropName !== lastCrop) {
            foundCropsSet.add(cropName);

            //region Create an empty crop structure if not already there.
            if (!cropData.hasOwnProperty(cropName)) {
              const calculatedColour = getCropColour(crops, cropName, false, true);
              cropData[cropName] = {
                colour: calculatedColour,
              };

              indicators.forEach(ind => {
                const indicator = ind.value;
                cropData[cropName][indicator] = {
                  data: [],
                  mean: null,
                  total: 0,
                  min: null,
                  max: null,
                }

                // copy the indicators processed into the summary data object.
                // so that the indicators "travel" with the data.
                // Only do this when processing the first crop.
                if (lastCrop === null) {
                  cropData.indicators.push(ind);
                }
              });
            }
            //endregion
          }

          indicators.forEach(ind => {
            const indicator = ind.value;    // Makes code a little clearer
            const datasetValue = dataset[indicator];
            if (datasetValue !== null) {    // Ignore nulls
              cropData[cropName][indicator].data.push(datasetValue);
              const roundedValue = Math.round(datasetValue * 1000) / 1000;
              if (cropData[cropName][indicator].min === null || roundedValue < cropData[cropName][indicator].min) {
                cropData[cropName][indicator].min = roundedValue;
              }
              if (cropData[cropName][indicator].max === null || roundedValue > cropData[cropName][indicator].max) {
                cropData[cropName][indicator].max = roundedValue;
              }
              cropData[cropName][indicator].total += datasetValue;
              cropData[cropName][indicator].label = ind.display;

              // Update the maxMin object to reflect the highest and lowest values
              // found for this indicator. Will be used to generate the axis later.
              if (maxMin[indicator].min === null || roundedValue < maxMin[indicator].min) {
                maxMin[indicator].min = roundedValue;
              }
              if (maxMin[indicator].max === null || roundedValue > maxMin[indicator].max) {
                maxMin[indicator].max = roundedValue;
              }
            }
          });

          lastCrop = cropName;
        }
      });
      //endregion

      //region Calculate the means and update objects.
      const foundCrops = Array.from(foundCropsSet);
      foundCrops.forEach(crop => {
        indicators.forEach(ind => {
          const indicator = ind.value;
          const calcMean = cropData[crop][indicator].total / cropData[crop][indicator].data.length;
          const roundedMean = Math.round(calcMean * 1000) / 1000;
          cropData[crop][indicator].mean = roundedMean;
        });
      });
      cropData.foundCrops = [...foundCrops];
      cropData.maxMins = maxMin;
      //endregion

      return cropData;
    }
  }
}

export function cropsToAbbrev(cropsList, crops) {
  // cropsList is a comma delimited string of crop names
  // crops is the list of crops as per API

  const abbrev = [];
  const cropArray = cropsList.split(",");
  cropArray.forEach(ca => {
    const aCrop = crops.find(c => c.Name.toLowerCase().trim() === ca.toLowerCase().trim());
    if (aCrop) {
      abbrev.push(aCrop.Abbreviation);
    }
  });

  return abbrev.join(",");
}

// export function cropsInRotation(crops, rotationName) {
//   let cropChecker = (arr, target) => target.every(v => arr.includes(v));
// }

export function sitesByStateObj(sites) {
  var res = {};
  if (sites) {
    if (Array.isArray(sites)) {
      sites.forEach((site) => {
        var state = site.State;
        var name = site.Name;
        if (!(state in res)) {
          res[state] = [name];
        } else {
          res[state].push(name);
        }
      });
    }
  }

  return res;
}

export function siteLatLongInfoObj(sites) {
  var res = [];
  if (sites) {
    if (Array.isArray(sites)) {
      sites.forEach((site) => {
        res.push({
          site: site.Name,
          state: site.State,
          lat: site.Lat,
          lng: site.Lon,
        })
      });
    }
  }

  return res;
}

export function getStatesList(sites) {
  const myStates = new Set();

  if (Array.isArray(sites)) {
    if (sites.length > 0) {
      sites.forEach((site) => {
        myStates.add(site.State);
      });
    }
  }

  if (myStates.size > 0) {
    return Array.from(myStates);
  } else {
    return [];
  }
}

export function convertSowingRulesToList(sowingRules) {
  const rulesList = [];

  sowingRules.forEach(sr => {
    const newObj = {
      id: sr.id,
      display: sr.Description,
      infokey: sr.infokey,
      detail: '',
      value: sr.id.toString(),
    };

    rulesList.push(newObj);
  });

  return rulesList;
}

export function getOverallMinMax(chartData) {
  // Expecting an array for each series (even if there is only 1 series)
  // Values for the series are to be stored in a 'data' property.
  const result = {
    min: 0,
    max: 0,
  };

  const dataSet = new Set();

  if (chartData) {
    if (chartData.length > 0) {
      chartData.forEach(sd => {
        if (sd.hasOwnProperty("data")) {
          sd.data.forEach(d => {
            dataSet.add(d);
          });
        }

        const dataAry = Array.from(dataSet);
        result.min = Math.min.apply(null, dataAry);
        result.max = Math.max.apply(null, dataAry);
      })
    }
  }

  return result;
}
